import { login, usersProfiles } from "../../api/auth/login";
import * as types from "../mutation-types";
import router, {
    asyncRouterMap,
    constantRouterMap,
    resetRouter
} from "../../router";
import {
    getToken,
    getUserId,
    removeToken,
    removeUserId,
    setToken,
    setUserId
} from "../../utils/auth";
import localStorage from "../../utils/localStorage";
import { deepCopy } from "../../utils/cloneObj";
import { profiles, businessFunctionList } from "../../api/merchant/merchants";
// import { $NOT_NETWORK } from '../../utils/errorCode'

// initial state
const state = {
    storeNumber: null,
    rolesSure: null,
    userId: getUserId(), // id
    account: "", // 账号
    avatar: "", // 头像
    token: getToken(), // 登录token
    authRules: [], // 权限列表
    routers: constantRouterMap, // 路由列表
    allRoutes: [], // 全部路由
    roles: [], // 该账户下的全部权限
    merchantInfo: localStorage.get("merchantInfo") || {}, // 商户信息
    change: false,
    userName: "",
    dataInfo: null,
    //独立计时系统
    IndependentTiming: ["kart-parameters"],

    //用户收银
    UserCashier: [
        "user",
        "membercard-list",
        "user-list",
        "user-detail",
        "membercard-list",
        "recharges-order-list",
        "game-order-list"
    ],
    //叫号
    CallStation: [
        "single-game-order-create-schedule",
        "single-game-order-create",
        "private-game-order-create",
        "single-game-order-list",
        "refund-list",
        "refund-detail",
        "project-list",
        "project-edit",
        "game-order-list",
        "game-order-detail"
    ],
    //排期
    Scheduling: [
        "schedule",
        "single-game-order-create-schedule",
        "single-game-order-create",
        "private-game-order-create",
        "single-game-order-list",
        "refund-detail",
        "refund-list",
        "game-order-list",
        "consumption-list",
        "project-list",
        "project-edit",
        "schedule-day-template",
        "schedule-week-template",
        "day-schedule",
        "game-order-detail",
        "activity-list",
        "activity-edit",
        "guide-list",
        "guide-edit",
        "otherInfo-edit"
    ],
    //收银统计
    CashierStatistics: [
        "kart-parameters",
        "finance",
        "store-statistics",
        "store-statistics-list",
        "store-sale-statistics",
        "income-expenditure-list",
        "store-member-statistics",
        "store-invite-statistics",
        "store-deal",
        "user-game-ranking-list",
        "project-sale-commission-list",
        "project-sale-statistics-list",
        "user-consumption-ranking-list",
        "user-items-ranking-list"
    ],
    //商品
    goods: [
        "product-list",
        "product-edit",
        "category",
        "brand",
        "label",
        "attribute",
        "product-order-list",
        "product-order-detail",
        "product-order-create",
        "single-game-order-list",
        "game-order-list",
        "refund-list",
        "refund-detail",
        "game-order-detail"
    ],
    //权限
    RightsManagement: [],

    //渠道运营
    ChannelOperations: [
        "staff-list",
        "staff-edit",
        "coupon-list",
        "coupon-edit",
        "coupon-consume-list",
        "staff-invite-code-list",
        "employee-invite",
        "invite-code-edit",
        "invite-code-consume-list",
        "invite-code-detail",
        "coupon-detail"
    ],
    //多门店
    moreStore: [],
    //设备管理//新增设备没给路由
    equipmentManagement: ["machine-list", "machine-edit", "kart-parameters"],
    //商家所有权限
    allBusinessRoles: [
        "main",
        "finance",
        "store-statistics",
        "store-statistics-list",
        "store-sale-statistics",
        "store-invite-statistics",
        "store-member-statistics",
        "income-expenditure-list",
        "kart-parameters",
        "coupon-list",
        "coupon-edit",
        "coupon-consume-list",
        "activity-list",
        "activity-edit",
        "guide-list",
        "guide-edit",
        "store-list",
        "store-edit",
        "store-staff-list",
        "store-staff-edit",
        "role-list",
        "role-edit",
        "log-list",
        "income-item-list",
        "platform-info-edit",
        "agreement-edit",
        "service-edit",
        "information-edit",
        "upgradeReward-edit",
        "payment-list",
        "payment-edit",
        "recharge-edit",
        "experience-list",
        "level-list",
        "invite-channel-list",
        "user-consumption-ranking-list",
        "user-items-ranking-list",
        "project-sale-statistics-list",
        "project-sale-commission-list",
        "user-game-ranking-list",
        "store-deal",
        "coupon-detail",
        "cashier-payment",
        "cashier-printer",
        "otherInfo-edit",
        "notification-list",
        "notification-rule"
    ],
    //门店所有权限
    allStoreRoles: [
        "notification-rule",
        "notification-list",
        "kart-parameters",
        "main",
        "finance",
        "store-statistics",
        "store-statistics-list",
        "store-sale-statistics",
        "store-invite-statistics",
        "store-member-statistics",
        "income-expenditure-list",
        "machine-list",
        "machine-edit",
        "product-list",
        "product-edit",
        "category",
        "brand",
        "label",
        "attribute",
        "coupon-list",
        "coupon-edit",
        "coupon-consume-list",
        "activity-list",
        "activity-edit",
        "log-list",
        "staff-list",
        "staff-edit",
        "staff-invite-code-list",
        "employee-invite",
        "invite-code-edit",
        "invite-code-consume-list",
        "invite-code-detail",
        "recharge-list",
        "promotions-edit",
        "payment-list",
        "payment-edit",
        "recharge-edit",
        "experience-list",
        "level-list",
        "user-consumption-ranking-list",
        "user-items-ranking-list",
        "project-sale-statistics-list",
        "project-sale-commission-list",
        "user-game-ranking-list",
        "store-deal",
        "coupon-detail",
        "otherInfo-edit",
        "sale-rule",
        "membersLevel-list",
        "level-list",
        "order-refund-rule",
        "refund-list",
        "consumption-list",
        "game-order-list",
        "product-order-list",
        "recharges-order-list",
        "product-order-detail",
        "project-list",
        "stock",
        "single-game-order-create",
        "single-game-order-create-schedule",
        "private-game-order-create",
        "product-order-create",
        "single-game-order-list",
        "refund-detail",
        "game-order-detail",
        "user",
        "user-list",
        "user-detail",
        "membercard-list",
        "schedule",
        "project-edit",
        "schedule-day-template",
        "schedule-week-template",
        "day-schedule"
    ]
};
// getters
const getters = {
    userId: state => state.userId,
    account: state => state.account,
    userName: state => state.userName,
    avatar: state => state.avatar,
    token: state => state.token,
    authRules: state => state.authRules,
    routers: state => state.routers,
    allRoutes: state => state.allRoutes, // lin
    roles: state => state.roles,
    change: state => state.change,
    merchantInfo: state => state.merchantInfo
};

// actions
const actions = {
    // 获取商户信息
    getMerchantInfo({ commit }) {
        profiles().then(res => {
            console.log("商户信息res", res);
            commit(types.RECEIVE_MERCHANT_INFO, res.data);
        });
    },
    // 手机号码与密码登录
    loginName({ commit, dispatch }, userInfo) {
        const account = userInfo.account ? userInfo.account.trim() : "";
        const password = userInfo.password ? userInfo.password.trim() : "";
        return new Promise((resolve, reject) => {
            login(account, password)
                .then(async res => {
                    console.log("actions: login:", res);
                    if (res.code === 200) {
                        let data = res.data;
                        console.info(
                            "--------------------------------------------------------------------------------"
                        );
                        console.info("data:", data);
                        console.info(
                            "--------------------------------------------------------------------------------"
                        );

                        commit(types.RECEIVE_ADMIN_ID, data.userId);
                        commit(
                            types.RECEIVE_ADMIN_TOKEN,
                            "Bearer " + data.token
                        );
                        // commit(types.RECEIVE_ADMIN_AUTH_RULES, []);
                        const tenantId = data.tenantId;
                        const merchantId = data.merchantId;
                        const storeId = data.storeId;
                        localStorage.set("tenantId", tenantId);
                        localStorage.set("merchantId", merchantId);
                        localStorage.set("storeId", storeId);
                        if (storeId) {
                            await dispatch("getOrderSetting");
                        }
                        await dispatch("userInfo");
                        await dispatch("getMerchantInfo");
                        await dispatch("filterRoutes");
                    }
                    console.log("Promise完事");
                    resolve(res);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    async filterRoutes(context) {
        console.log(
            localStorage.get("merchantId"),
            localStorage.get("tenantId"),
            "这里是获取到的id",
            context.state.merchantInfo.id,
            context.state.merchantInfo.tenantId
        );
        let _menus = [];
        let menusResult = [];
        let businessRoles = [];
        let storeRoles = [];
        let BusinessDefaultRoles = [];
        let StoreDefaultRoles = [];
        //商家功能与商家所有权限取交集
        let newBusinessRoles = [];
        //商家功能与门店所有权限取交集
        let newStoreRoles = [];
        //获取商家功能列表

        const functionLists = await businessFunctionList(
            localStorage.get("merchantId"),
            localStorage.get("tenantId")
        );
        const functionList = functionLists.data.results.filter(
            item => item.enabled
        );
        console.log(functionList, "functionList");
        // console.log(
        //     functionList.data.results.find(
        //         item => item.featureId === "6420407f01b3a3383284fdff"
        //     ),
        //     "判断有没有"
        // );
        if (
            functionList.find(
                item => item.featureId === "6420407f01b3a3383284fdff"
            )
            //独立计时系统
            // /user/membercard-list
        ) {
            menusResult.push(context.state.IndependentTiming.map(item => item));
            console.log(menusResult, "menusResult");
        }
        if (
            functionList.find(
                item => item.featureId === "642040a101b3a3383284fe00"
            )
            //用户
            // /user/membercard-list
        ) {
            menusResult.push(context.state.UserCashier.map(item => item));
            console.log(menusResult, "menusResult");
        }
        if (
            functionList.find(
                item => item.featureId === "642040b701b3a3383284fe01"
            )
            //叫号
            // /user/membercard-list
        ) {
            menusResult.push(context.state.CallStation.map(item => item));
            console.log(menusResult, "menusResult");
        }
        if (
            functionList.find(
                item => item.featureId === "642040cb01b3a3383284fe02"
            )
            // 排期
            // /user/membercard-list
        ) {
            menusResult.push(context.state.Scheduling.map(item => item));
            console.log(menusResult, "menusResult--------------------");
        }
        if (
            functionList.find(
                item => item.featureId === "642040e801b3a3383284fe03"
            )
            // 收银
            // /store/store-statistics
        ) {
            menusResult.push(context.state.CashierStatistics.map(item => item));
            console.log(menusResult, "menusResult");
        }
        if (
            functionList.find(
                item => item.featureId === "642040f701b3a3383284fe04"
            )
            // 商品管理
            // /user/membercard-list
        ) {
            menusResult.push(context.state.goods.map(item => item));
            console.log(menusResult, "menusResult");
        }
        if (
            functionList.find(
                item => item.featureId === "6420410801b3a3383284fe05"
            )
            // 权限
            // /user/membercard-list
        ) {
            context.commit(types.ROLESSURE, 2);
            context.state.rolesSure = 2;
            menusResult.push(context.state.RightsManagement.map(item => item));
            console.log(menusResult, "menusResult");
        } else {
            context.commit(types.ROLESSURE, 1);
            context.state.rolesSure = 1;
        }
        if (
            functionList.find(
                item => item.featureId === "6420411c01b3a3383284fe06"
            )
            // 渠道
            // /user/membercard-list
        ) {
            menusResult.push(context.state.ChannelOperations.map(item => item));
            console.log(menusResult, "menusResult");
        }
        if (
            functionList.find(
                item => item.featureId === "6420414301b3a3383284fe07"
            )
            // 设备管理
            // /user/membercard-list
        ) {
            menusResult.push(
                context.state.equipmentManagement.map(item => item)
            );
            console.log(menusResult, "menusResult");
        }
        if (
            functionList.find(
                item => item.featureId === "6420415d01b3a3383284fe08"
            )
            // 多门店
            // /user/membercard-list
        ) {
            context.commit(types.STORENUMBER, 2);

            context.state.storeNumber = 2;
            menusResult.push(context.state.moreStore.map(item => item));
            console.log(menusResult, "menusResult22222222222");
        } else {
            context.commit(types.STORENUMBER, 1);

            context.state.storeNumber = 1;
        }
        const allFUnctionRoles = [];
        allFUnctionRoles.push(context.state.UserCashier);
        allFUnctionRoles.push(context.state.CallStation);
        allFUnctionRoles.push(context.state.Scheduling);
        allFUnctionRoles.push(context.state.CashierStatistics);
        allFUnctionRoles.push(context.state.goods);
        allFUnctionRoles.push(context.state.RightsManagement);
        allFUnctionRoles.push(context.state.ChannelOperations);
        allFUnctionRoles.push(context.state.moreStore);
        allFUnctionRoles.push(context.state.equipmentManagement);
        BusinessDefaultRoles = context.state.allBusinessRoles.filter(item => {
            return !allFUnctionRoles.flat().includes(item);
        });
        StoreDefaultRoles = context.state.allStoreRoles.filter(item => {
            return !allFUnctionRoles.flat().includes(item);
        });
        console.log(BusinessDefaultRoles, "筛选的商家默认权限");
        console.log(StoreDefaultRoles, "筛选的门店默认权限");
        businessRoles = menusResult.flat();
        newBusinessRoles = context.state.allBusinessRoles.filter(item => {
            return menusResult.flat().includes(item);
        });
        newStoreRoles = context.state.allStoreRoles.filter(item => {
            return menusResult.flat().includes(item);
        });
        if (context.state.dataInfo.storeId) {
            const res = context.state.dataInfo.roles[0].permissions.map(
                item => item.router
            );
            console.log("----------这里是测试门店——————————————————————————");
            storeRoles = res.filter(item => {
                return newStoreRoles.includes(item);
            });
            _menus = storeRoles.concat(StoreDefaultRoles);
        } else {
            _menus = newBusinessRoles.concat(BusinessDefaultRoles);
        }
        menusResult = [];
        storeRoles = [];

        console.log(context.state.dataInfo, "登陆拿到的用户信息");
        // console.log(_menus, "过滤出来的权限");
        // 获取当前用户的menus,里面有他可以访问的路由信息
        // console.log(context.state.UserCashier, "context.state.UserCashier");
        console.log("context.rootState", context.rootState);
        // 获取权限下全部路由的name
        // const _menus = context.rootState.admin.roles.map(item => item.router);
        const filterName = context.rootState.admin.roles.filter(item => {
            return item.name === "项目库存";
        });
        console.log(filterName, "filterName");
        context.commit(types.RECEIVE_ALLROUTES, _menus);
        console.log(_menus);

        // 获取到后，和动态路由进行比较
        let asyncRoutes = deepCopy(asyncRouterMap[0]);
        asyncRoutes.children = [];
        asyncRouterMap[0].children.forEach((v, index) => {
            // 这里注意，如果赋值给原数组会 引发引用类型值变化的问题
            asyncRoutes.children[index] = deepCopy(v);
            asyncRoutes.children[index].children = [];
            v.children.forEach(child => {
                if (_menus.includes(child.name)) {
                    asyncRoutes.children[index].children.push(child);
                }
            });
        });
        let childArr = asyncRoutes.children.filter(
            item => item.children.length > 0
        );
        asyncRoutes.children = childArr;
        let _newRoutes = [];
        // // 404 页面放在静态路由的最后面（是添加到router中，仓库也要）
        _newRoutes.push({ path: "*", redirect: "/404" });
        _newRoutes.push(asyncRoutes);
        console.log("_newRoutes", _newRoutes);

        // // // addRoutes动态添加
        router.addRoutes(_newRoutes);
        // // 合并到vuex中的routers
        context.commit(types.RECEIVE_ROUTERS, [
            ...constantRouterMap,
            ..._newRoutes
        ]);
        context.commit("setChange", true);
    },
    userInfo({ commit }) {
        let staffId = localStorage.get("staffId");
        return new Promise((resolve, reject) => {
            usersProfiles()
                .then(res => {
                    if (res.code !== 200) {
                        reject("登录失效");
                    }
                    const data = res.data || {};
                    console.log("***********************************");
                    console.log(data);
                    commit(types.RECEIVE_DATA_INFO, data);
                    commit(types.RECEIVE_ADMIN_NAME, data.username);
                    commit(types.RECEIVE_ADMIN_AVATAR, data.avatar);
                    // commit(types.RECEIVE_ADMIN_AUTH_RULES, data.authRules);
                    commit(types.RECEIVE_ROLES, data.roles[0].permissions);
                    commit("setUserName", data.nickName);
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    // 登出
    loginOut({ commit }) {
        commit(types.RECEIVE_ADMIN_ID, "");
        commit(types.RECEIVE_ADMIN_TOKEN, "");
        resetRouter();
        commit(types.RECEIVE_ROLES, []);
        commit(types.RECEIVE_ROUTERS, constantRouterMap);
        commit(types.RECEIVE_ALLROUTES, []);
        // return new Promise((resolve, reject) => {

        //     // logout()
        //     //     .then(() => {
        //     //         commit(types.RECEIVE_ADMIN_ID, "");
        //     //         commit(types.RECEIVE_ADMIN_TOKEN, "");
        //     //         // commit(types.RECEIVE_ADMIN_AUTH_RULES, []);
        //     //         commit(types.RECEIVE_ROLES, [], { root: true });
        //     //         resolve();
        //     //     })
        //     //     .catch(error => {
        //     //         reject(error);
        //     //     });
        // });
    },

    // 前端 登出
    fedLogout({ commit }) {
        return new Promise(resolve => {
            console.log("调用了额");
            commit(types.RECEIVE_ADMIN_ID, "");
            commit(types.RECEIVE_ADMIN_TOKEN, "");
            // commit(types.RECEIVE_ADMIN_AUTH_RULES, []);
            resetRouter();
            commit(types.RECEIVE_ROLES, []);
            commit(types.RECEIVE_ROUTERS, constantRouterMap);
            commit(types.RECEIVE_ALLROUTES, []);
            resolve();
        });
    },
    /**
     * 过滤路由列表
     * @param commit
     * @param data
     * @returns {Promise}
     */
    filterRouter({ commit }, data) {
        const { accessedRouters } = data;
        if (accessedRouters && accessedRouters.length > 0) {
            commit(types.RECEIVE_ROUTERS, accessedRouters);
        }
    }
};

// mutations
const mutations = {
    [types.RECEIVE_MERCHANT_INFO](state, info) {
        state.merchantInfo = info;
        localStorage.set("merchantInfo", info);
    },
    [types.RECEIVE_ADMIN_ID](state, userId) {
        state.userId = userId;
        if (userId === "") {
            removeUserId();
        } else {
            setUserId(userId);
        }
    },
    [types.RECEIVE_ADMIN_TOKEN](state, token) {
        state.token = token;
        if (token === "") {
            removeToken();
        } else {
            setToken(token);
        }
    },
    [types.RECEIVE_ADMIN_NAME](state, account) {
        state.account = account;
    },
    [types.ROLESSURE](state, rolesSure) {
        state.rolesSure = rolesSure;
    },

    [types.STORENUMBER](state, storeNumber) {
        state.storeNumber = storeNumber;
    },
    [types.RECEIVE_ADMIN_AVATAR](state, avatar) {
        state.avatar = avatar;
    },
    [types.RECEIVE_ADMIN_AUTH_RULES](state, authRules) {
        state.authRules = authRules;
    },
    [types.RECEIVE_ROUTERS](state, routers) {
        state.routers = routers;
    },
    [types.RECEIVE_DATA_INFO](state, data) {
        state.dataInfo = data;
    },
    [types.RECEIVE_ALLROUTES](state, newRoutes) {
        // console.log("传进来的", newRoutes);
        state.allRoutes = newRoutes;
    },
    [types.RECEIVE_ROLES](state, roles) {
        state.roles = roles;
    },
    setChange(state, isChange) {
        state.change = isChange;
    },
    setUserName(state, name) {
        state.userName = name;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
